import React from 'react';

function CardIcon4() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="25"
      fill="none"
      viewBox="0 0 38 25"
    >
      <g clipPath="url(#clip0_2_8243)">
        <path
          fill="#000"
          d="M35 .6H3c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3v-18c0-1.7-1.4-3-3-3z"
          opacity="0.07"
        ></path>
        <path
          fill="#D64D00"
          d="M35 1.6c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2v-18c0-1.1.9-2 2-2h32z"
        ></path>
        <path
          fill="#FF8A00"
          d="M12 12.6v3.7c0 .3-.2.3-.5.2-1.9-.8-3-3.3-2.3-5.4.4-1.1 1.2-2 2.3-2.4.4-.2.5-.1.5.2v3.7zm2 0V8.9c0-.3 0-.3.3-.2 2.1.8 3.2 3.3 2.4 5.4-.4 1.1-1.2 2-2.3 2.4-.4.2-.4.1-.4-.2v-3.7zm7.2-7H13c3.8 0 6.8 3.1 6.8 7s-3 7-6.8 7h8.2c3.8 0 6.8-3.1 6.8-7s-3-7-6.8-7z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2_8243">
          <path
            fill="#fff"
            d="M0 0H38V24H0z"
            transform="translate(0 .6)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default CardIcon4;
